import {
	OfferSavingsTable,
	OfferSavingsTableInput
} from "@/types/dto/landing-page/landing-page";
import basicInfoMultipleCtasFactory from "@/factories/common/basic-info-multiple-cta-factory";


const offerSavingsTableFactory = (data: OfferSavingsTableInput): OfferSavingsTable | undefined => {
	if (!data?.salesTable) {
		return undefined;
	}

	const textBlockComponent = basicInfoMultipleCtasFactory(
		data.textBlockComponent ?? data.basicInfo
	);

	return {
		title: data.title,
		textBlockComponent: {
			...textBlockComponent,
			ctas: textBlockComponent.ctas?.map(cta =>
				cta.ctaType === "internalLink" && !cta.buttonVariant
					? { ...cta, buttonVariant: "Secondary" }
					: cta
			)
		},
		salesTable: {
			header: data.salesTable.header,
			richTextTable: data.salesTable.richTextTable
		}
	};
};

export default offerSavingsTableFactory;
